import { Modal, Row, Col } from 'react-bootstrap';
import React from 'react';
const MinimumOrderModal = ({ show, total_gr, onHide, onAccept, onReject }) => (
  <Modal show={show} onHide={onHide} style={{ zIndex: '10000000000' }}>
    <Modal.Body className='rtl' style={{ fontSize: '.9rem' }}>
      <span style={{ fontWeight: 'bold' }}>همکار گرامی،</span>
      <br />
      <span>حداقل خرید عمده فروشی در هر سفارش ۲۵ گرم و خرید شما {total_gr} گرم میباشد.</span>
      <br />
      <span>در صورت خرید کمتر از ۲۵ گرم، </span>
      <span style={{ fontWeight: 'bold' }}>دو درصد</span>
      <span> به اجرت محصولات اضافه خواهد شد.</span>
    </Modal.Body>
    <Modal.Footer>
      <Row style={{ width: '100%', margin: '0px' }}>
        <Col style={{ width: '50%', padding: '0px 5px' }}>
          <button className='btn-success border-0 color-white rounded p-2 modal-buttons' onClick={onAccept}>
            <span>قبول و ادامه</span>
          </button>
        </Col>
        <Col style={{ width: '50%', padding: '0px 5px' }}>
          <button className='border-0 rounded p-2 modal-buttons btn-disable' onClick={onReject}>
            <span>ادامه خرید</span>
          </button>
        </Col>
      </Row>
    </Modal.Footer>
  </Modal>
);

export default MinimumOrderModal;
